module.exports = __webpack_public_path__ + "static/media/best-place.4ad71061.svg";